import React from 'react';

const Spinner = ({ 
  size = 'md', 
  color = 'blue', 
  fullScreen = false, 
  className = '' 
}) => {
  const sizes = {
    sm: 'h-5 w-5 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-4',
    xl: 'h-16 w-16 border-4'
  };

  const colors = {
    blue: 'border-blue-500 border-t-transparent',
    white: 'border-white border-t-transparent',
    gray: 'border-gray-500 border-t-transparent',
    purple: 'border-purple-500 border-t-transparent',
    green: 'border-green-500 border-t-transparent',
    red: 'border-red-500 border-t-transparent'
  };

  const spinnerElement = (
    <div 
      className={`animate-spin rounded-full ${sizes[size] || sizes.md} ${colors[color] || colors.blue} ${className}`}
      role="status"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );

  // If fullScreen is true, wrap it in a fixed centered overlay
  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
        {spinnerElement}
      </div>
    );
  }

  // Otherwise, just return the spinner (you can wrap it in a flex container manually where used)
  return spinnerElement;
};

export default Spinner;